<template>
	<b-modal
		hide-footer
		:no-close-on-backdrop="true"
		ref="modal-view"
		size="md"
		centered
		hide-header
		content-class="supplier-modal"
	>
		<div class="text-center mb-4">
			<div class="supplier-icon mb-3">
				<md-icon icon="business" class="icon-lg"/>
			</div>
			<h4 class="mb-1">Selecciona un proveedor</h4>
			<p class="text-muted small mb-0">Elige el proveedor con el que deseas trabajar</p>
		</div>

		<form @submit="onSubmit">
			<b-form-group label="Proveedor" label-class="font-weight-bold">
				<multiselect
					v-model="selectedOption"
					:options="options"
					:searchable="true"
					:close-on-select="true"
					:show-labels="false"
					placeholder="Buscar proveedor..."
					label="text"
					track-by="value"
					:allow-empty="false"
				>
					<template #noResult>
						<span>No se encontraron proveedores</span>
					</template>
					<template #noOptions>
						<span>No hay proveedores disponibles</span>
					</template>
				</multiselect>
			</b-form-group>

			<b-button
				block
				variant="primary"
				type="submit"
				class="mt-4 py-2"
				:disabled="!selectedOption"
			>
				<span v-if="loading">
					<b-spinner small class="mr-2"/>
					Accediendo...
				</span>
				<span v-else>
					Acceder
				</span>
			</b-button>
		</form>
	</b-modal>
</template>

<script>
import Resize from "../../helpers/Resize.js";
import Multiselect from 'vue-multiselect';

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: {
		Multiselect
	},
	data() {
		return {
			selectedOption: null,
			Opts: {},
			loading: false,
			error: false
		};
	},
	computed: {
		selected() {
			return this.selectedOption ? this.selectedOption.value : null;
		},
		options() {
			if (Array.isArray(this.Opts.supplier)) {
				return this.Opts.supplier.map(item => ({
					value: item.id,
					text: item.code
				}));
			}
			return [];
		}
	},
	methods: {
		loadModel(options) {
			this.$refs["modal-view"].show();
			this.Opts = options;
			this.selectedOption = null;
			this.loading = false;
			this.error = false;
		},

		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;

			this.$root.api.post('/auth/system', null, {
				headers: {
					"X-SC-TYPE": 'supplier',
					"X-SC-SYSTEM": this.selected,
				}
			}).then((response) => {
				this.$root.store.setSystemData(response.data);

				this.$root.api.post('/auth/me').then((response2) => {
					this.$root.store.setUserData(response2.data);
					this.$router.push('/');
				});
			}).catch(() => {
				this.loading = false;
				this.error = true;
			});
		}
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.supplier-icon {
	width: 70px;
	height: 70px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border-radius: 50%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.supplier-icon .icon-lg {
	font-size: 32px;
	color: white;
}

::v-deep .supplier-modal {
	border-radius: 12px;
	padding: 1.5rem;
}

::v-deep .multiselect__tags {
	border-radius: 8px;
	border: 1px solid #ced4da;
	padding: 10px 40px 10px 12px;
	min-height: 46px;
}

::v-deep .multiselect__single {
	margin-bottom: 0;
	padding: 0;
}

::v-deep .multiselect__placeholder {
	margin-bottom: 0;
	padding: 0;
	color: #6c757d;
}

::v-deep .multiselect__option--highlight {
	background: #667eea;
}

::v-deep .multiselect__option--selected.multiselect__option--highlight {
	background: #764ba2;
}
</style>
